import React from 'react';
import PropTypes from 'prop-types';
import { Loading } from '../Common';
import { LoadingButton } from '../Messages/Messages';

const propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

/**
 * @name LoggedInNavLoadingSkeleton
 * @description A loading skeleton component that mimics the structure of the logged-in
 * left navigation tabs while data is being fetched. Provides visual continuity and
 * improved user experience during loading states by displaying placeholder elements
 * that match the layout of the actual navigation components.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isLoading - Controls whether the loading skeleton is displayed
 * @param {boolean} props.isMobile - Determines mobile-specific styling and behavior
 *
 * @returns {React.ReactElement} A skeleton structure with loading placeholders for navigation tabs
 */
function LoggedInNavLoadingSkeleton({ isLoading, isMobile }) {
  return (
    <div
      className="acct-left-nav account-left-nav--logged-in"
      data-testid="user-nav--loading"
    >
      <div className="acct-left-nav__content">
        <LoadingButton showText={false} />
      </div>
      <div className="acct-left-nav__content acct-left-nav__content--full-width">
        <div className="acct-left-nav__tabs-container">
          <div className="acct-tabs" data-is-mobile={isMobile}>
            {
              Array.from({ length: 5 }).map((_, index) => (
                <Loading
                  className="acct-tabs__link loading-tab-skeleton"
                  isLoading={isLoading}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${index}-loading-tab-skeleton`}
                >
                  <div className="loading-tab-skeleton__content" />
                </Loading>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

LoggedInNavLoadingSkeleton.propTypes = propTypes;

export default LoggedInNavLoadingSkeleton;
